import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import DashboardNote from '#components/m/MeineAusbildung/DashboardNote'
import Text from '#components/a/Text'
import {BerufwechselConfirmModal} from './BerufwechselConfirmModal'
import Api from '#services/api'

export function AufbauAusbildungsNote({aufbauAusbildungsBeruf}) {
  return (
    <DashboardNote
      title={i18n.t('aufbauausbildungsberuf_title')}
      text={i18n.t('aufbauausbildungsberuf_note_text', [aufbauAusbildungsBeruf])}
    >
      <BerufwechselConfirmModal
        apiCallback={async () => await Api.prepareAufbauausbildung()}
        headlineText={i18n.t('aufbauausbildungsberuf_confirmation_dialog_headline')}
        buttonText={i18n.t('aufbauausbildungsberuf_change_beruf_button')}
      >
        <Text text={i18n.t('aufbauausbildungsberuf_confirmation_dialog_text')} />
      </BerufwechselConfirmModal>
    </DashboardNote>
  )
}

AufbauAusbildungsNote.propTypes = {
  aufbauAusbildungsBeruf: PropTypes.string,
}

export default AufbauAusbildungsNote
